import { toPrecision, toValue } from "../../utils/Number";
import axios from "axios";
export class BalanceService {

    async call(actor: string) {

        try {
        
            const balanceValue = await window.proton.link.client.get_currency_balance('snipcoins', actor, 'SNIPS');
            try {

                const rawValue = balanceValue[0].split(' ')
                const intValue = parseInt(rawValue[0]);
                return intValue;
            } catch (e) { 

                console.warn('No SNIPS balance')

            }
                   
      } catch (e) {
        throw new Error("No proton session!");
      }
    }
}

export class PoolBalanceService {

    async call(actor: string) {

        try {
        
            const balanceValue = await window.proton.link.client.get_currency_balance('snipcoins', 'snipstake', 'SNIPS');
            try {

                const rawValue = balanceValue[0].split(' ')
                const intValue = parseInt(rawValue[0]);
                return intValue;
            } catch (e) { 

                console.warn('No SNIPS balance')

            }
                   
      } catch (e) {
        throw new Error("No proton session!");
      }
    }
}

export class RewardPoolBalanceService {

    async call(actor: string) {

        try {
        
            const rewardPool = await window.proton.link.client.get_table_rows({
                code: "snipstake",
                table: "rewardpool",
                scope: "snipstake",
                limit:1
                
            })
            try {

                console.log (rewardPool.rows)
                if (rewardPool.rows.length>0) { 

                    let rewardPoolValuation = rewardPool.rows.reduce( (prev:number,current:any):number => { 

                        console.log(current)
                        return prev+=parseFloat(current.pool)

                    },0)
                    
                    return {
                        
                        poolAmount:rewardPoolValuation
                        
                    }
    
                }
    
                return;
            } catch (e) { 

                console.warn('No SNIPS balance')

            }
                   
      } catch (e) {
        throw new Error(e);
      }
    }
}

export class APRService { 

    async call (actor: string): Promise<any | undefined> { 

        try {

            const config = await window.proton.link.client.get_table_rows({
                code: "snipstake",
                table: "config",
                scope: "snipstake",
                limit:1
                
            })
            if (config.rows.length>0) { 

                const configRow = config.rows[0];
                
                if (configRow) return {
                    
                    apr:configRow.apr 
                    
                }

            }

            return;

        } catch (e) { 

            console.warn('account not found')

        }
    }

}

export class AccountService {
    async call (actor: string): Promise<any | undefined> { 

        try {

            const accounts = await window.proton.link.client.get_table_rows({
                code: "snipstake",
                table: "accounts",
                scope: "snipstake",
                limit:1000
                
            })
            if (accounts.rows.length>0) { 

                const actorAccount = accounts.rows.filter(function (account) {
                    return account.key == actor;
                })[0];
                
                if (actorAccount) return {
                    key: actorAccount.key,
                    rewardsAmount:parseInt(actorAccount.rewardsAmount),
                    level:this.getAccountMembershipLevel(actorAccount.level),
                    stakesAmount:parseInt(actorAccount.stakesAmount),
                    unstakeAmount:parseInt(actorAccount.unstakeAmount),
                    lastUpdatedDate:parseInt(actorAccount.lastUpdatedDate)
                    
                }

            }

            return;

        } catch (e) { 

            console.warn('account not found')

        }
    }

    getAccountMembershipLevel(level: string): string { 
        
        if (level == "level.lite") return "Lite";
        if (level == "level.pro") return "Pro";
        if (level == "level.advisor") return "Advisor";
        return 'Free'


    }
    
    getAccountMembershipLevelByStakingAmount(amount: number,base:number = 0): string { 
        
        if (amount+base >= 10000000) return "Advisor";
        if (amount+base < 10000000 && amount >= 1000000)
          return "Pro";
        if (amount+base < 1000000 && amount >= 100000) return "Lite";
        return "Free";

    }

}
  
export class StakeUpdateService {

    async call(actor: string):Promise<any | undefined> { 

        const updateUnstake = {
            account: 'snipstake',
            name: 'stake.update',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
              account: actor,
      
            }
          }
      
        
        const updateReward = {
            account: 'snipstake',
            name: 'reward.updt',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
              account: actor,
            }
          }

        try { 

            return await window.proton.link.transact(
                {
                    actions:[updateReward,updateUnstake]
                }, {
                    blockBehind: 3,
                    expireSeconds:30
                }
            )

        } catch (e) { 

            return;

        }
    }

}

export class StakeService { 

    async call(actor:string,amount:number):Promise<any | undefined> {
        
        const stake = {
            account: 'snipcoins',
            name: 'transfer',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
                from: actor,
                to:'snipstake',
                quantity: `${toPrecision(amount, 4)} SNIPS`,
                memo:`Staking ${new Date().toDateString()}`
            }
          }
      
        console.log(stake)
          
        
        try { 

            return await window.proton.link.transact(
                {
                    actions:[stake]
                }, {
                    blockBehind: 3,
                    expireSeconds:30
                }
            )

        } catch (e) { 

            return 

        }

        return 

    }


}

export class UnstakeService { 

    async call(actor:string,amount:number):Promise<any> {
        
        const unstake = {
            account: 'snipstake',
            name: 'stake.unstk',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
                account: actor,
                quantity:`${toPrecision(amount, 4)} SNIPS`
            }
          }
      
          
        
        try { 

            return await window.proton.link.transact(
                {
                    actions:[unstake]
                }, {
                    blockBehind: 3,
                    expireSeconds:30
                }
            )

        } catch (e) { 

            return 

        }

        return 

    }


}

export class ClaimService { 

    async call(actor:string):Promise<any> {
        
        const unstake = {
            account: 'snipstake',
            name: 'reward.claim',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
                account: actor,
                
            }
          }
      
          
        
        try { 

            return await window.proton.link.transact(
                {
                    actions:[unstake]
                }, {
                    blockBehind: 3,
                    expireSeconds:30
                }
            )

        } catch (e) { 

            return 

        }

        return 

    }


}

export class RestakeService { 

    async call(actor:string):Promise<any> {
        
        const restake = {
            account: 'snipstake',
            name: 'reward.rstk',
            authorization: [{
                actor: actor,
                permission:'active'
            }],
            data: {
                account: actor, 
            }
          }
      
          
        
        try { 

            return await window.proton.link.transact(
                {
                    actions:[restake]
                }, {
                    blockBehind: 3,
                    expireSeconds:30
                }
            )

        } catch (e) { 

            return e

        }

        return 

    }


}

export class StakeHistoryService {

    async call(actor: string): Promise<any[] | undefined>{

        try {

            const accounts = await window.proton.link.client.get_table_rows({
                code: "snipstake",
                table: "stakes",
                scope: actor,
                limit:1000
                
            })
            if (accounts.rows.length>0) { 


                return accounts.rows.map((row) => { return {...row,stakeAmount:parseFloat(row.stakeAmount)}})

            }

            return;

        } catch (e) { 

            console.warn('account not found')

        }

        return;
        
    }

}
 
export class AccountLevelUpdateService {

    async call(endpoint:string,actor:string) { 

        const url = `${Wo_Ajax_Requests_File()}?f=stake&s=update-actor-level`;

    const formData: FormData = new FormData();
    formData.append("actor", actor);
    try {
      const request = await axios({
        url: url,
        method: "POST",
        data: formData,
      });

      return request
    } catch (e) {
      throw new Error("Withdraw request fail!");
    }
  }

    }

export class AutoStakeUpdateService {

    
    async call(endpoint:string,actor:string) { 

        const url = `${Wo_Ajax_Requests_File()}?f=stake&s=update-stake`;

    const formData: FormData = new FormData();
    formData.append("actor", actor);
    try {
      const request = await axios({
        url: url,
        method: "POST",
        data: formData,
      });

      return request
    } catch (e) {
      throw new Error("Withdraw request fail!");
    }
  }

    }


 